import { useContext } from 'react';
import { MobileAppContext } from '../../providers/MobileAppProvider';

export default function useMobileApp() {
  return useContext(MobileAppContext);
}
